import { render, staticRenderFns } from "./ModalSimpleToDetail.vue?vue&type=template&id=304eaf82&scoped=true&"
import script from "./ModalSimpleToDetail.vue?vue&type=script&lang=js&"
export * from "./ModalSimpleToDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalSimpleToDetail.vue?vue&type=style&index=0&id=304eaf82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304eaf82",
  null
  
)

export default component.exports